module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/depth_views/3-e82c92675ba0437208bf702268242d89.jpg";